<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Χρήστες</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createUser()">Προσθήκη χρήστη</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showUser(item.id)"
            clickable-rows
          >
          <template #registered="{item}">
            <td>
              {{item.registered | formatDate}}
            </td>
          </template>
          <template #status-filter>
            <div class="selectFilter">
              <CSelect
                :options="statusOptions"
                :value.sync="selectedOption"
              />
            </div>
          </template>
          <template #status="{item}">
            <td>
              <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                v-if="item.name!='Kukarika'"
                color="primary"
                class="btn-icon mr-2"
                @click.stop="editUser( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
              <CButton
                v-if="you!=item.id && item.name!='Kukarika'"
                color="danger"
                class="btn-icon"
                @click.stop="deleteUser( item.id )"
                v-c-tooltip="'Διαγραφή'"
              >
                <CIcon name="cilTrash" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    }
});

const fields = [
  { 
    key: 'name', 
    label: 'Ονοματεπώνυμο'
  },
  { 
    key: 'email', 
    label: 'Email'
  },
  { 
    key: 'registered', 
    label: 'Εγγραφή'
  },
  { 
    key: 'roles', 
    label: 'Ρόλοι'
  },
  {
    key: 'status',
    label: 'Κατάσταση',
    sorter: false,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Users',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή'],
      loading: true,
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const status = item.status
        return status == this.selectedOption
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    editLink (id) {
      return `users/${id.toString()}/edit`
    },
    showUser ( id ) {
      const userLink = this.userLink( id );
      this.$router.push({path: userLink});
    },
    editUser ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteUser ( id ) {
      const deleteLink = `users/${id.toString()}/delete`
      this.$router.push({path: deleteLink})
    },
    // deleteUser ( id ) {
    //   let self = this;
    //   let userId = id;
    //   axios.post('/api/users/' + id + '?token=' + localStorage.getItem("api_token"), {
    //     _method: 'DELETE'
    //   })
    //   .then(function (response) {
    //       self.message = 'Επιτυχής διαγραφή χρήστη.';
    //       self.showAlert();
    //       self.getUsers();
    //   }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: '/login' });
    //   });
    // },
    createUser () {
      this.$router.push({path: 'users/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getUsers (){
      let self = this;
      axios.get('/api/users?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.users;
        self.statusOptions = [...self.statusOptions, ...new Set(self.items.map(item => item.status))];
        self.loading = false;
        self.you = response.data.you;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getUsers();
  }
}
</script>
